export default __webpack_public_path__ + "static/media/about.2adab314.png";